/**
 * Open the global upgrade panel (CLA-906) for a gated feature, without a
 * request having 402'd — used by locked affordances like nav chips. Rides
 * the same `claro:plan-required` event the api client dispatches.
 */
export function openUpgradePanel(feature: string, requiredPlan?: string | null) {
  window.dispatchEvent(
    new CustomEvent('claro:plan-required', {
      detail: { code: 'plan_required', feature, required_plan: requiredPlan ?? null },
    }),
  )
}
